import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63c73608"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Submit")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, { title: "Modify Password" }),
    _createVNode(_component_van_field, {
      modelValue: $setup.state.password,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.state.password) = $event)),
      type: $setup.isShowOldPassword?'text':'password',
      clearable: "",
      "right-icon": $setup.isShowOldPassword?'closed-eye':'eye',
      placeholder: "Current password",
      onClickRightIcon: _cache[1] || (_cache[1] = ($event: any) => ($setup.isShowOldPassword = !$setup.isShowOldPassword))
    }, null, 8, ["modelValue", "type", "right-icon"]),
    _createVNode(_component_van_field, {
      modelValue: $setup.state.newpassword,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.state.newpassword) = $event)),
      type: $setup.isShowNewPassword?'text':'password',
      clearable: "",
      "right-icon": $setup.isShowNewPassword?'closed-eye':'eye',
      placeholder: "New password",
      onClickRightIcon: _cache[3] || (_cache[3] = ($event: any) => ($setup.isShowNewPassword = !$setup.isShowNewPassword))
    }, null, 8, ["modelValue", "type", "right-icon"]),
    _createVNode(_component_van_field, {
      modelValue: $setup.state.repassword,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.state.repassword) = $event)),
      type: $setup.isShowConPassword?'text':'password',
      clearable: "",
      "right-icon": $setup.isShowConPassword?'closed-eye':'eye',
      placeholder: "Password confirm",
      onClickRightIcon: _cache[5] || (_cache[5] = ($event: any) => ($setup.isShowConPassword = !$setup.isShowConPassword))
    }, null, 8, ["modelValue", "type", "right-icon"]),
    _createVNode(_component_van_button, {
      type: "primary",
      color: "#f87622",
      style: {"border-radius":"4px"},
      onClick: $setup.submit
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}